import { useSettings } from '@backpackjs/storefront';
import Script from 'next/script';

export function BeamProductDetailsPageWrapper() {
  const settings = useSettings();
  const beamSettings = settings?.beam;

  if (!beamSettings) return null;

  return (
    <>
      <Script
        strategy="afterInteractive"
        type="module"
        crossOrigin="anonymous"
        src="https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/product-details-page.esm.js"
      />
      <div className="my-[40px] border border-[#83888E] bg-[#E9F0F7]">
        <beam-product-details-page
          apiKey={beamSettings.beamApiKey}
          storeId={beamSettings.beamStoreId}
          baseUrl="https://api.beamimpact.com"
        />
      </div>
    </>
  );
}
